export default "__VITE_ASSET__DsDf4FSA__"